import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';

var RADIAN = Math.PI / 180;
// position labels 25px away from the outer radius and render percentage
var CustomPieLabelOutside = function (_a) {
    var cx = _a.cx, cy = _a.cy, midAngle = _a.midAngle, outerRadius = _a.outerRadius, percent = _a.percent;
    if (cx && cy && midAngle && outerRadius && percent) {
        var radius = outerRadius + 25;
        var x = cx + radius * Math.cos(-midAngle * RADIAN);
        var y = cy + radius * Math.sin(-midAngle * RADIAN);
        var textAnchor = x > cx ? 'start' : x === cx ? 'middle' : 'end';
        var dominantBaseline = midAngle > 45 && midAngle < 135
            ? 'text-bottom'
            : midAngle > 225 && midAngle < 315
                ? 'hanging'
                : 'central';
        return (jsx("text", __assign({ x: x, y: y, "data-testid": "custom-pie-label-outside", textAnchor: textAnchor, dominantBaseline: dominantBaseline }, { children: "".concat((percent * 100).toFixed(0), "%") })));
    }
    return null;
};
// position label between the inner and outer radius
var CustomPieLabelCenter = function (_a) {
    var cx = _a.cx, cy = _a.cy, innerRadius = _a.innerRadius, midAngle = _a.midAngle, outerRadius = _a.outerRadius, percent = _a.percent;
    if (cx && cy && midAngle && innerRadius != undefined && outerRadius && percent) {
        var radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        var x = cx + radius * Math.cos(-midAngle * RADIAN);
        var y = cy + radius * Math.sin(-midAngle * RADIAN);
        return (jsx("text", __assign({ x: x, y: y, textAnchor: "middle", dominantBaseline: "central", className: "recharts-pie-text-overlay", "data-testid": "custom-pie-label-center" }, { children: "".concat((percent * 100).toFixed(0), "%") })));
    }
    return null;
};

export { CustomPieLabelCenter, CustomPieLabelOutside };
